/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICipCtaLinkViewProps } from './cip-cta-link';

export default (props: ICipCtaLinkViewProps) => {
    const { text, href, classNames, target, ariaLabel } = props;
    return (
        <a href={href} className={classNames} target={target} aria-label={ariaLabel}>
            <span className='cip-cta-link__text'>{text}</span>
        </a>
    );
};
